<button
  mat-flat-button
  type="button"
  color="secondary"
  class="mat-tiny-button creator-select-menu-button !min-w-0"
  [matMenuTriggerFor]="menu"
  (click)="calculateCreatorHasCustomValueMap()"
>
  <div class="flex items-center gap-2 font-medium text-base">
    @if (globalCreatorSelected()) {
      <div class="flex items-center justify-center gap-2">
        <app-icon src="icons/world.svg" [size]="16" />
        <span>
          {{ 'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.creatorSelectMenu.allCreators' | translate }}
        </span>
      </div>
    } @else if (selectedCreatorIds().size === 1) {
      @let creator = selectedCreator();

      <app-icon-badge
        [content]="creator.icon"
        [fallbackText]="creator.name"
        [size]="20"
        [iconSize]="20"
        [fontSize]="12"
        [borderRadius]="100"
      />
      <span
        class="max-w-40 text-ellipsis line-clamp-1"
        matTooltip
        matTooltipPosition="above"
        [appTextClampTooltip]="selectedCreator().name"
      >
        {{ creator.name }}
      </span>
    } @else {
      <div class="flex items-center justify-center gap-2">
        <app-icon src="icons/creators.svg" [size]="16" />
        <div class="flex items-center gap-1">
          <span>{{ selectedCreatorIds().size }}</span>
          <span>{{ 'shared.creators' | translate }}</span>
        </div>
      </div>
    }

    <app-icon src="icons/edit.svg" [size]="16" />
  </div>
</button>

<mat-menu #menu="matMenu" class="mat-filter-menu">
  <button mat-menu-item class="pointer-events-none">
    <span class="text-xs text-shikenso-purple-base-60">
      {{ 'shared.creators' | translate }}
    </span>
  </button>

  @for (creator of platformSortedCreatorOptions(); track creator?.id) {
    @let lastSelectedCreatorExceptAllCreators =
      selectedCreatorIds().size === 2 && selectedCreatorIds().has(ALL_CREATORS_ID) && creator.id !== ALL_CREATORS_ID;

    <div
      matTooltipPosition="left"
      [matTooltip]="
        creator.id === customModeCreatorId() && ctaForm()?.invalid
          ? ('pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.creatorSelectMenu.branchModeCreatorWithErrorsCannotBeUnselected'
            | translate)
          : disabledCreatorIds().has(creator.id)
            ? ('pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.creatorSelectMenu.creatorDoesNotHavePlatform'
              | translate)
            : ('pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.creatorSelectMenu.lastSelectedCreator'
              | translate)
      "
      [matTooltipDisabled]="
        !(selectedCreatorIds().size === 1 && selectedCreatorIds().has(creator.id)) &&
        !disabledCreatorIds().has(creator.id) &&
        !lastSelectedCreatorExceptAllCreators &&
        !(creator.id === customModeCreatorId() && ctaForm()?.invalid)
      "
    >
      @let isCreatorDisabled =
        (selectedCreatorIds().size === 1 && selectedCreatorIds().has(creator.id)) ||
        disabledCreatorIds().has(creator.id) ||
        lastSelectedCreatorExceptAllCreators ||
        (ctaForm()?.invalid && creator.id === customModeCreatorId());

      <button mat-menu-item [disabled]="isCreatorDisabled" (click)="onCreatorSelect($event, creator)">
        <div class="flex items-center justify-between w-full gap-2">
          <div class="flex items-center gap-1">
            @if (creator.id === ALL_CREATORS_ID) {
              <div class="flex items-center gap-1">
                <span>
                  {{ 'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.globalAllCreators' | translate }}
                </span>
              </div>
            } @else {
              <div class="flex items-center gap-1 pl-3">
                <app-icon-badge
                  [content]="creator.icon"
                  [fallbackText]="creator.name"
                  [size]="24"
                  [iconSize]="32"
                  [fontSize]="18"
                  [borderRadius]="100"
                />
                <span matTooltip class="text-ellipsis line-clamp-1 w-[160px]" [appTextClampTooltip]="creator.name">
                  {{ creator.name }}
                </span>
              </div>
            }
          </div>

          @let selected = selectedCreatorIds().has(creator.id) && !disabledCreatorIds().has(creator.id);

          <div class="flex items-center justify-end flex-1 gap-2">
            <app-icon
              [src]="selected ? 'icons/circle-check.svg' : 'icons/circle.svg'"
              [color]="selected ? 'var(--shikenso-pink-base)' : 'var(--shikenso-purple-base)'"
              [size]="16"
            />

            @let isAllCreators = creator.id === ALL_CREATORS_ID;

            <div
              matTooltipPosition="above"
              [matTooltip]="
                'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.modeCannotBeChanged' | translate
              "
              [matTooltipDisabled]="!selected || ctaForm()?.valid || !selectedPlatform() || isAllCreators"
              [class.opacity-0]="isAllCreators"
            >
              <button
                mat-flat-button
                class="mat-tiny-button !w-24 !px-0"
                [color]="customModeCreatorId() === creator.id ? 'secondary' : 'secondary-transparent'"
                [disabled]="!selected || ctaForm()?.invalid || !selectedPlatform() || isAllCreators"
                (click)="onCreatorCustomModeChange($event, creator)"
              >
                <div
                  class="text-[10px]"
                  [ngClass]="
                    selected && isCreatorDisabled ? 'text-shikenso-purple-base' : 'text-shikenso-purple-base-60'
                  "
                >
                  @if (customModeCreatorId() === creator.id) {
                    {{
                      'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.creatorSelectMenu.exitOverride'
                        | translate
                    }}
                  } @else {
                    @if (
                      ctaForm() && creatorHasCustomValueMap().get(`${creator.id!}_${ctaForm()!.controls.id.value}`)
                    ) {
                      {{
                        'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.creatorSelectMenu.editOverride'
                          | translate
                      }}
                    } @else {
                      {{
                        'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.creatorSelectMenu.customize'
                          | translate
                      }}
                    }
                  }
                </div>
              </button>
            </div>
          </div>
        </div>
      </button>
    </div>
  }
</mat-menu>
